module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-shadow-12.62a4f805.png";